'use strict';

module.exports = value => typeof value === 'symbol';
